export interface SessionTokenStore {
  read(): string | null;
  write(token: string): void;
  clear(): void;
}

const TOKEN_KEY = 'exylon.panel-v2.staff-session';
/** Staff middleware requires a bearer. Persist only in this tab, never the
 * password, a decoded identity, tenant selectors, or cached permission grants. */
/** @internal */
export function tabSessionTokenStore(storage: Storage): SessionTokenStore {
  return {
    read: () => storage.getItem(TOKEN_KEY),
    write: (token) => storage.setItem(TOKEN_KEY, token),
    clear: () => storage.removeItem(TOKEN_KEY),
  };
}

/** This tab's store, read at each use: the Panel's boundary opens with it. */
export function browserTabSessionTokenStore(): SessionTokenStore {
  return {
    read: () => tabSessionTokenStore(window.sessionStorage).read(),
    write: (token) => tabSessionTokenStore(window.sessionStorage).write(token),
    clear: () => tabSessionTokenStore(window.sessionStorage).clear(),
  };
}
